import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// 懒加载页面组件
const Login = () => import('@/views/Login.vue')
const Layout = () => import('@/components/Layout.vue')
const Dashboard = () => import('@/views/Dashboard.vue')

// 系统管理模块
const SystemFunction = () => import('@/views/system/Function.vue')
const SystemRole = () => import('@/views/system/Role.vue')
const SystemUser = () => import('@/views/system/User.vue')
const SystemConfig = () => import('@/views/system/Config.vue')
const ReleaseAnnouncement = () => import('@/views/system/ReleaseAnnouncement.vue')

// 充值管理模块
const CustomerBrief = () => import('@/views/recharge/Brief.vue')
const Recharge = () => import('@/views/recharge/Recharge.vue')
const RechargeDetail = () => import('@/views/recharge/RechargeDetail.vue')
const Rate = () => import('@/views/recharge/Rate.vue')
const BillStatistic = () => import('@/views/recharge/BillStatistic.vue')
const Contract = () => import('@/views/recharge/Contract.vue')

// 数据管理模块
const TaskManagement = () => import('@/views/data/Task.vue')
const BackCustomer = () => import('@/views/data/BackCustomer.vue')
const BackTestCustomer = () => import('@/views/data/BackTestCustomer.vue')
const CancelCustomer = () => import('@/views/data/CancelCustomer.vue')
const UnameType = () => import('@/views/data/UnameType.vue')

// 监控模块
const Monitor = () => import('@/views/monitor/Monitor.vue')
const MonitorException = () => import('@/views/monitor/Exception.vue')

// API管理模块
const ApiCostDetail = () => import('@/views/api/CostDetail.vue')
const ApiBasePrice = () => import('@/views/api/BasePrice.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '首页仪表板' }
      },
      // 系统管理
      {
        path: '/system/function',
        name: 'SystemFunction',
        component: SystemFunction,
        meta: { title: '系统功能管理' }
      },
      {
        path: '/system/role',
        name: 'SystemRole', 
        component: SystemRole,
        meta: { title: '系统角色管理' }
      },
      {
        path: '/system/user',
        name: 'SystemUser',
        component: SystemUser,
        meta: { title: '系统用户管理' }
      },
      {
        path: '/system/dict',
        name: 'SystemConfig',
        component: SystemConfig,
        meta: { title: '字典管理' }
      },
      {
        path: '/system/release-announcement',
        name: 'ReleaseAnnouncement',
        component: ReleaseAnnouncement,
        meta: { title: '发版公告' }
      },
      // 充值管理
      {
        path: '/recharge/brief',
        name: 'CustomerBrief',
        component: CustomerBrief,
        meta: { title: '客户简报管理' }
      },
      {
        path: '/recharge/recharge',
        name: 'Recharge',
        component: Recharge,
        meta: { title: '充值管理' }
      },
      {
        path: '/recharge/detail',
        name: 'RechargeDetail',
        component: RechargeDetail,
        meta: { title: '充值详情' }
      },
      {
        path: '/recharge/rate',
        name: 'Rate',
        component: Rate,
        meta: { title: '汇率管理' }
      },
      {
        path: '/recharge/bill-statistic',
        name: 'BillStatistic',
        component: BillStatistic,
        meta: { title: '账单统计' }
      },
      {
        path: '/recharge/contract',
        name: 'Contract',
        component: Contract,
        meta: { title: '合同管理' }
      },
      // 数据管理
      {
        path: '/data/task',
        name: 'TaskManagement',
        component: TaskManagement,
        meta: { title: '任务管理' }
      },
      {
        path: '/data/back-customer',
        name: 'BackCustomer',
        component: BackCustomer,
        meta: { title: '备份客户管理' }
      },
      {
        path: '/data/back-test-customer',
        name: 'BackTestCustomer',
        component: BackTestCustomer,
        meta: { title: '测试客户管理' }
      },
      {
        path: '/data/cancel-customer',
        name: 'CancelCustomer',
        component: CancelCustomer,
        meta: { title: '取消客户管理' }
      },
      {
        path: '/data/uname-type',
        name: 'UnameType',
        component: UnameType,
        meta: { title: '用户名类型管理' }
      },
      // 监控模块
      {
        path: '/monitor/index',
        name: 'Monitor',
        component: Monitor,
        meta: { title: '监控面板' }
      },
      {
        path: '/monitor/exception',
        name: 'MonitorException',
        component: MonitorException,
        meta: { title: '异常监控' }
      },
      // API管理
      {
        path: '/api/cost-detail',
        name: 'ApiCostDetail',
        component: ApiCostDetail,
        meta: { title: '客户专属报价' }
      },
      {
        path: '/api/base-price',
        name: 'ApiBasePrice',
        component: ApiBasePrice,
        meta: { title: '产品基准报价' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 后端URL到前端路由的映射表（可按需扩展/覆盖）
export const backendUrlToRoute = (url) => {
  const map = new Map([
    ['/api/index', '/'],
    ['/api/sys/function/pageList', '/system/function'],
    ['/api/sys/role/pageList', '/system/role'],
    ['/api/sys/user/pageList', '/system/user'],
    ['/api/config/page', '/system/dict'],
    ['/api/releaseAnnouncement/page', '/system/release-announcement'],

    ['/api/brief/page', '/recharge/brief'],
    ['/api/recharge/page', '/recharge/recharge'],
    ['/api/recharge/pageList', '/recharge/detail'],
    ['/api/rate/page', '/recharge/rate'],
    ['/api/billstatistic/page', '/recharge/bill-statistic'],
    ['/api/contract/page', '/recharge/contract'],

    ['/api/data/taskpage', '/data/task'],
    ['/api/backcustomer/page', '/data/back-customer'],
    ['/api/backtestcustomer/page', '/data/back-test-customer'],
    ['/api/cancelcustomer/page', '/data/cancel-customer'],
    ['/api/unametype/page', '/data/uname-type'],

    ['/api/monitor/index', '/monitor/index'],
    ['/api/monitor/exception', '/monitor/exception'],

    ['/api/apiCost/page', '/api/cost-detail'],
    ['/api/apiCost/basePage', '/api/base-price']
  ])
  // 精确匹配
  if (map.has(url)) return map.get(url)
  // 兜底：若是/api/xxx/page 这种，则按猜测路径转换
  if (/^\/api\/.+\/page/.test(url)) {
    const name = url.replace(/^\/api\//, '').replace(/\/page.*/, '')
    return '/' + name.replace(/\//g, '/').replace('billstatistic', 'recharge/bill-statistic')
  }
  return '/'
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth !== false && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
